@if (loaded() && !campaignInactive()) {
  <div class="wrapper" [ngStyle]="highContrast() ? { filter: 'saturate(0)' } : { filter: 'saturate(1)' }">
    @if (!voucherGroup().hideHeaderImage) {
      <div class="wrapper-bg" role="banner">
        <div class="header-wrapper">
          <div class="header-image-wrapper">
            <div class="header-img" style="background-image:url('{{ township().logoImageUrl }}');"></div>
          </div>
          <div class="header-text-button-wrapper">
            <h1 class="header-text">
              {{ township().name }}
            </h1>
            <div class="header-button-wrapper">
              <button (click)="setHighContrast()" mat-flat-button class="header-button">
                <mat-icon>contrast</mat-icon>
                Hoog contrast
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="collective-request-wrapper">
        @if (vouchersUnavailable()) {
          <div class="statistics">
            <div class="subtitle">Helaas zijn er geen bonnen beschikbaar voor deze collectiviteit.</div>
          </div>
        } @else {
          <form [formGroup]="collectiveForm" (ngSubmit)="submitCollectiveRequest()">
            <div class="voucher-ids-section">
              <h2>Adressen die mee doen met de collectiviteit</h2>
              <p>Voer minimaal {{ voucherGroup().minParticipants }} adressen in om door te gaan.</p>

              <div formArrayName="addresses">
                @for (group of addresses.controls; track group; let i = $index) {
                  <div [formGroupName]="i" class="address-group">
                    <h3 class="address-header">Adres {{ i + 1 }}</h3>
                    <div class="address-row-top">
                      <mat-form-field appearance="outline" class="address-field postal-code">
                        <mat-label>Postcode</mat-label>
                        <input
                          matInput
                          formControlName="postal"
                          placeholder="1234AB"
                          (input)="updateAllValidators(i)"
                        />
                        @if (addresses.at(i).get('postal')?.hasError('required')) {
                          <mat-error>Dit veld is verplicht.</mat-error>
                        }
                        @if (addresses.at(i).get('postal')?.hasError('postalValidator')) {
                          <mat-error>De postcode moet bijvoorbeeld 1234AB zijn.</mat-error>
                        }
                      </mat-form-field>

                      @if (addresses.length > 1) {
                        <button
                          type="button"
                          mat-icon-button
                          color="warn"
                          class="remove-btn"
                          (click)="removeAddress(i)"
                          aria-label="Verwijder adres"
                        >
                          <mat-icon>remove_circle</mat-icon>
                        </button>
                      }
                    </div>

                    <div class="address-row-bottom">
                      <mat-form-field appearance="outline" class="address-field house-number">
                        <mat-label>Huisnummer</mat-label>
                        <input
                          matInput
                          formControlName="houseNumber"
                          placeholder="10"
                          (input)="updateAllValidators(i)"
                        />
                        @if (addresses.at(i).get('houseNumber')?.hasError('required')) {
                          <mat-error>Dit veld is verplicht</mat-error>
                        }
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="address-field addition">
                        <mat-label>Toevoeging</mat-label>
                        <input
                          matInput
                          formControlName="houseNumberAddition"
                          placeholder="a"
                          (input)="updateAllValidators(i)"
                        />
                        <mat-hint>Optioneel</mat-hint>
                        @if (addresses.at(i).get('houseNumberAddition')?.hasError('pattern')) {
                          <mat-error>Alleen letters en cijfers toegestaan</mat-error>
                        }
                      </mat-form-field>
                    </div>

                    @if (addresses.at(i).hasError('duplicate')) {
                      <mat-error>Dit adres is al ingevoerd</mat-error>
                    }
                    @if (addresses.at(i).hasError('serverError')) {
                      <mat-error>{{ addresses.at(i).getError('serverError') }}</mat-error>
                    }
                  </div>
                }
              </div>

              <button
                type="button"
                mat-raised-button
                color="primary"
                (click)="addAddress()"
                class="add-voucher-btn"
                [disabled]="vouchersUnavailable()"
              >
                <mat-icon>add</mat-icon>
                Adres toevoegen
              </button>

              <div class="voucher-count-info">
                <p>
                  Aantal ingevulde adressen: {{ getFilledAddressesCount() }} (minimaal
                  {{ voucherGroup().minParticipants }} vereist)
                </p>
              </div>

              <div class="actions">
                <button
                  type="submit"
                  mat-flat-button
                  class="submit-btn"
                  [disabled]="!canSubmit()"
                  [class.spinner]="awaitingRequest()"
                >
                  @if (!awaitingRequest()) {
                    Aanvraag indienen
                  } @else {
                    &nbsp;
                  }
                </button>
              </div>
            </div>
          </form>
        }
      </div>
    }
  </div>
} @else if (campaignInactive()) {
  <div class="wrapper" [ngStyle]="highContrast() ? { filter: 'saturate(0)' } : { filter: 'saturate(1)' }">
    <div class="wrapper-bg" role="banner">
      <div class="header-wrapper">
        <div class="header-image-wrapper">
          <div class="header-img" style="background-image:url('{{ township()?.logoImageUrl }}')"></div>
        </div>
        <div class="header-text-button-wrapper">
          <h1 class="header-text">{{ township()?.name }}</h1>
          <div class="header-button-wrapper">
            <button (click)="setHighContrast()" mat-flat-button class="header-button">
              <mat-icon>contrast</mat-icon>
              Hoog contrast
            </button>
          </div>
        </div>
      </div>
    </div>
    <p class="inactive-title">
      Het aanvragen van een collectief is niet meer mogelijk omdat deze campagne niet actief is.
    </p>
  </div>
} @else if (!loaded()) {
  <div class="loading-container">
    <mat-spinner></mat-spinner>
  </div>
}
